export const sampleTypeTestsStructure = {
  sampleTypeId: "",
  panels: [
    {
      name: "",
      testIds: "",
      panelId: "1",
      panelOrder: 0,
    },
  ],
  tests: [
    {
      id: "",
      name: "",
      userBenchChoice: false,
    },
  ],
};
